import ChsAddress from 'domain/types/ChsAddress';

interface IDisplayAddress {
  address: ChsAddress;
}

const DisplayAddress = (props: IDisplayAddress) => {
  const {
    address: {
      houseNumber,
      halfNumber,
      streetName,
      streetDir,
      streetType,
      unitType,
      unitNumber,
      city,
      state,
      zipCode,
    },
  } = props;
  return (
    <>
      {[
        houseNumber,
        // 1/2 address field removed from screen
        halfNumber === 'Y' ? '1/2' : null,
        streetDir,
        streetName,
        streetType,
      ]
        .filter((str) => Boolean(str))
        .join(' ')}
      <br />
      {[unitType, unitNumber].filter((str) => Boolean(str)).join(' ')}
      {(unitType || unitNumber) && <br />}
      {[city, state, zipCode].filter((str) => Boolean(str)).join(', ')}
      <br />
    </>
  );
};

export default DisplayAddress;
